import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["alt"];
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from '@emotion/react';
var imageStyles = css({
  maxWidth: '100%',
  height: 'auto'
});
var actionItemContainerStyles = css({
  display: 'flex',
  margin: "var(--ds-space-0, 0px)".concat(" -4px"),
  /* When there is more than one action, place primary action visually on the
   right, but keep it's position as the first focusable element in the DOM */
  flexDirection: 'row-reverse'
});
var actionItemStyles = css({
  margin: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)")
});

/**
 * __Dialog image__
 *
 * An optional header image in spotlight dialogs.
 *
 * @internal
 */
export var DialogImage = function DialogImage(_ref) {
  var alt = _ref.alt,
    props = _objectWithoutProperties(_ref, _excluded);
  return (
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    jsx("img", _extends({
      css: imageStyles,
      alt: alt
    }, props))
  );
};

/**
 * __Dialog action item container__
 *
 * Flex wrapper around dialog action items.
 *
 * @internal
 */
export var DialogActionItemContainer = function DialogActionItemContainer(_ref2) {
  var children = _ref2.children;
  return jsx("div", {
    css: actionItemContainerStyles
  }, children);
};

/**
 * __Dialog action item__
 *
 * Action items shown inside of the dialog.
 *
 * @internal
 */
export var DialogActionItem = function DialogActionItem(_ref3) {
  var children = _ref3.children;
  return jsx("div", {
    css: actionItemStyles
  }, children);
};